module.exports = __webpack_public_path__ + "static/media/new-application.cfb222e6.png";